<template>
  <v-dialog v-model="dialog" max-width="520" @keydown.esc="close">
    <v-card>
      <v-card-title>
        {{ $t('provisionBatch.details.reportDialog.title') }}
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <p class="subtitle-2 mb-3">{{ $t('provisionBatch.details.reportDialog.selectAreas') }}</p>

        <v-checkbox
          v-model="allSelected"
          :label="$t('provisionBatch.details.reportDialog.selectAll')"
          dense
          class="mt-0 mb-1"
          hide-details
          @change="toggleAll"
        ></v-checkbox>

        <v-divider class="mb-2"></v-divider>

        <v-checkbox
          v-for="area in availableAreas"
          :key="area"
          v-model="selected"
          :value="area"
          :label="area"
          dense
          hide-details
          class="mt-0"
        ></v-checkbox>

        <v-alert
          v-if="selected.length === 0"
          type="warning"
          text
          dense
          class="mt-3 mb-0"
        >
          {{ $t('provisionBatch.details.reportDialog.noAreasSelected') }}
        </v-alert>

        <v-text-field
          v-model="reference"
          :label="$t('provisionBatch.details.reportDialog.reportReference')"
          outlined
          dense
          clearable
          class="mt-4 mb-0"
          hide-details
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">
          {{ $t('provisionBatch.details.reportDialog.cancel') }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="selected.length === 0"
          @click="generate"
        >
          <v-icon left>mdi-file-document-outline</v-icon>
          {{ $t('provisionBatch.details.reportDialog.generate') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { generateProvisionBatchReport } from "@/utils/provisionBatchReportGenerator";

export default {
    name: "ProvisionBatchReportDialog",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        batch: {
            type: Object,
            required: true
        },
        summary: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selected: [],
            reference: ""
        };
    },
    computed: {
        dialog: {
            get() { return this.value; },
            set(val) { this.$emit("input", val); }
        },
        availableAreas() {
            if (!this.summary || !this.summary.areaSummaries) return [];
            return this.summary.areaSummaries.map(a => a.area);
        },
        allSelected: {
            get() {
                return this.availableAreas.length > 0 &&
          this.selected.length === this.availableAreas.length;
            },
            set() {}
        }
    },
    watch: {
        value(val) {
            if (val) {
                this.selected = [...this.availableAreas];
                this.reference = "";
            }
        }
    },
    methods: {
        toggleAll(checked) {
            this.selected = checked ? [...this.availableAreas] : [];
        },
        generate() {
            generateProvisionBatchReport(
                this.batch,
                this.summary,
                this.selected,
                this.reference || null
            );
            this.close();
        },
        close() {
            this.dialog = false;
        }
    }
};
</script>
